
import { Vue, Component, Prop } from "vue-property-decorator";
import { LocalizationState } from "@/store/modules/LocalizationModule";
import { mapState } from "vuex";

@Component({
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
    }),
  },
})
export default class vAccordion extends Vue {
  @Prop() accordionTitleTranslationKey!: string;
  @Prop() title!: string;

  isExpanded = false;
  localizationState: LocalizationState;

  expandAccordion() {
    this.isExpanded = !this.isExpanded;
  }

  get translations() {
    return this.localizationState.translations;
  }

  get displayTitle() {
    if (this.title) {
      return this.title;
    }

    else if (this.accordionTitleTranslationKey) {
      return this.translations.get(this.accordionTitleTranslationKey);
    }
  }
}

